import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import {
  getIsAuthenticated,
  getMyProfile,
} from "src/domain/app/redux/auth/auth-selectors";
import {
  setCountNotificationsUnread,
  setNewNotification,
} from "src/domain/app/redux/notifications/notification-slice";
import { AUTH_TOKEN, remoteSocketIoUrl } from "src/shared/constants/AppConst";
import MainUtils from "src/shared/utils/main";
import urlJoin from "url-join";
import { getCountNotificationsUnread } from "src/domain/app/redux/notifications/notification-selectors";
import { useCookies } from "react-cookie";

export const useInitSocketIo = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const countNotificationsUnread = useSelector(getCountNotificationsUnread);
  const myProfile = useSelector(getMyProfile);
  const [checkJoin, setCheckJoin] = useState(false);
  const [socket, setSocket] = useState<any>();
  const [cookies] = useCookies([AUTH_TOKEN]);

  useEffect(() => {
    if (isAuthenticated) {
      // Get auth token from cookies
      const authToken = cookies[AUTH_TOKEN];

      if (!authToken) {
        console.warn("No auth token found in cookies");
        return;
      }

      const newSocket = io(urlJoin(remoteSocketIoUrl!), {
        transports: ["websocket", "polling"],
        auth: {
          token: authToken,
        },
      });

      // Handle authentication errors
      newSocket.on("connect_error", (error) => {
        if (
          error.message === "Authentication error" ||
          error.message === "Invalid token"
        ) {
          console.error("Socket authentication failed:", error.message);
          // Optionally dispatch an action to handle auth failure
          // dispatch(authActions.logout());
        } else {
          console.error("Socket connection error:", error);
        }
      });

      setSocket(newSocket);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && !checkJoin && socket) {
      socket?.on("connect", function () {
        console.log("Socket connected successfully with authentication");
      });
      setCheckJoin(true);
    }
  }, [isAuthenticated, checkJoin, socket]);

  useEffect(() => {
    if (isAuthenticated && socket) {
      socket?.on("receiveNotification", (item: any) => {
        if (
          !MainUtils.isEmptyValue(item) &&
          item?.RecieversUsersEmail &&
          item?.RecieversUsersEmail?.includes(myProfile?.email)
        ) {
          dispatch(setNewNotification(item));
          dispatch(
            setCountNotificationsUnread(Number(countNotificationsUnread) + 1),
          );
        }
      });
    }
  }, [dispatch, isAuthenticated, socket, countNotificationsUnread, myProfile]);

  // Cleanup socket on unmount
  useEffect(() => {
    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, [socket]);
};
